import React from 'react';
import { connect } from 'react-redux';
import { map, keys, toPairs, filter, compose, concat } from 'ramda';
import { selectAllHorses } from '../reducers/horsesReducer';
import { selectSale } from '../reducers/salesReducer';
import { CSVLink } from 'react-csv';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const CatalogCSV = ({
    horses,
    sale,
}) => {
    const visibleCatalogColumns = compose(
        map(i => i[0].slice(i[0].indexOf('_') + 1)),
        filter(i => i[0].indexOf('show_') === 0 && i[1]),
    )(toPairs(sale));

    const extraColumns = [
        'session',
        'sire_of_dam',
        'property_line',
        'private_sale',
        'year_of_birth',
        'preg_status',
        'cover_date',
        'sold_as_description',
    ];

    // master list of columns to display
    const columnsArray = concat(visibleCatalogColumns, extraColumns);

    // all columns on one horse
    const horseColumns = horses && keys(horses[0]).slice(2, 28);

    // keeping intended order and filtering out non-visible columns
    const headers = compose(
        map(column => column.replace(/_/g, ' ').toUpperCase()),
        filter(column => columnsArray.indexOf(column) !== -1),
    )(horseColumns);
    headers.unshift('SALE TITLE');

    const saleTitle = [global.drupalSettings.catalogues.sale_name];
    const data = map((horse) => {
        return concat(saleTitle, compose(
            map((i) => {
                if (typeof i[1] === 'string') {
                    return i[1].replace(/,/g, '').toUpperCase();
                } else if (typeof i[1] === 'boolean') {
                    return i[1] ? 'Y' : '';
                }
                return i[1];
            }),
            filter(i => columnsArray.indexOf(i[0]) !== -1),
        )(toPairs(horse)));
    }, horses);


    let csvContent = '';
    csvContent += `${headers.join(',')}\n`;

    data.forEach((infoArray, index) => {
        const dataString = infoArray.join(',');
        csvContent += index < data.length ? `${dataString}\n` : dataString;
    });

    return (
            <CSVLink
                data={csvContent}
                filename={`${saleTitle}.csv`}
                className="btn btn-link"
                target="_self">
                <FontAwesomeIcon style={{verticalAlign:"middle" }} className="control-button" icon={['fas', 'file-csv']} />
            </CSVLink>
    );
};

const mapState = (state) => {
    return {
        sale: selectSale(state),
    };
};


export default connect(mapState)(CatalogCSV);
